const { REACT_APP_CONFIGURATION } = process.env;

let isAppConfigurationEnabled = false;

if (
  REACT_APP_CONFIGURATION &&
  REACT_APP_CONFIGURATION?.toLowerCase() === 'true'
) {
  isAppConfigurationEnabled = true;
}

// MI Config : page sizes for datasource and file collection table query
export const DATA_SOURCE_QUERY_PAGE_SIZE = 1000;
export const FC_TABLE_QUERY_PAGE_SIZE = 1000;

export default isAppConfigurationEnabled;
